import React from "react";
import JobTags from "./JobTags";

interface JobData {
  url: string;
  image: string;
  title: string;
  practice_name: string;
  practice_city: string;
  practice_state: string;
  compensation?: string;
  position_type?: string;
  skills?: any[];
  temp_date?: string;
  benefit_medical?: boolean;
  benefit_dental?: boolean;
  benefit_vision?: boolean;
  benefit_401k?: boolean;
  benefit_pto?: boolean;
  benefit_bonuses?: boolean;
}

interface JobSearchJobProps {
  job: JobData;
  noTags?: boolean;
}

const JobSearchJob: React.FC<JobSearchJobProps> = ({ job, noTags }) => {
  return (
    <div className="field">
      <li>
        <a href={encodeURI(job.url)} target="_blank" rel="noopener noreferrer">
          <img src={encodeURI(job.image)} alt="" className="job-avatar" />
          <div className="job-list-content">
            <h4 className="fullname">{job.title}</h4>
            <div className="job-icons">
              <span>
                <i className="fa fa-briefcase"></i> {job.practice_name}
              </span>
              <span>
                <i className="fa fa-map-marker"></i> {job.practice_city},{" "}
                {job.practice_state}
              </span>
              {job.compensation && (
                <span>
                  <i className="fa fa-money"></i> {job.compensation}
                </span>
              )}
            </div>
            {!noTags && <JobTags job={job as any} />}
          </div>
          {noTags && (
            <a href="https://www.ziprecruiter.com/jobs" id="jobs_widget_link">
              <span>Job Search by</span>{" "}
              <span id="zr_logo_container">
                <img
                  id="zr_logo"
                  src="https://www.ziprecruiter.com/img/logos/logo-sm-black-304px.png"
                  alt="ZipRecruiter"
                />
              </span>
            </a>
          )}
        </a>
      </li>
      <div className="clearfix"></div>
    </div>
  );
};

export default JobSearchJob;
